// extracted by mini-css-extract-plugin
module.exports = {"modals":"styles_modals__3TZ4l"};